import React, { useEffect, useState } from "react";
import NewLeaveApplicationStyles from "./NewLeaveApplication.styles";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import { Box, Grid, Step, StepLabel, Stepper, Typography } from "@mui/material";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as CloseIcom } from "../../../../assets/icons/close.svg";
import LeaveApplyForm from "../LeaveApplyForm/LeaveApplyForm";
import { applyLicenseKey } from "../../../../utils/License";
const stepData = ["Leave Application"];

interface CustomProps {
  isDialogOpen: boolean;
  handleCloseLeavedetailsForm: Function;
  leaveInfo?:any
}

const NewLeaveApplication = (props: CustomProps) => {
  const classes = NewLeaveApplicationStyles;
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState<{
    [k: number]: boolean;
  }>({});
 useEffect(() => {
      applyLicenseKey();
    }, []);
  // step 1 form validation method
  const handleStepOneValidation = () => {
    return true;
  };

  const totalSteps = () => {
    return stepData.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  // go to next page method
  const nextStep = () => {
    if (handleStepOneValidation()) {
      const newActiveStep = isLastStep() && !allStepsCompleted() ? stepData.findIndex((step, i) => !(i in completed)) : activeStep + 1;
      setActiveStep(newActiveStep);
    } else if (activeStep >= 1) {
      setActiveStep(activeStep + 1);
    }
  };

  const stepperMethod = () => {
    return (
      <>
        {/* <Stepper activeStep={activeStep} orientation='vertical' sx={classes.stepperStyle}>
          {stepData.map((label, index) => {
            return (
              <Step key={index} sx={{ display: "flex", justifyContent: "center" }}>
                <StepLabel sx={classes.stepLabel}>
                  <Typography sx={classes.label}>{label}</Typography>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper> */}
      </>
    );
  };

  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcom onClick={() => props.handleCloseLeavedetailsForm()} />
      </Box>
    );
  };
console.log(props,"PROPS CHECK")
  const getAllContent = (activeStep: number) => {
    switch (activeStep) {
      case 0:
        return <LeaveApplyForm nextStep={nextStep}  leaveInfo={props.leaveInfo} handleclose={props.handleCloseLeavedetailsForm} />;
      default:
        break;
    }
  };

  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.profileWrapper}>
          <Grid container>
            <Grid item xs={2}>
              {/* {stepperMethod()} */}
            </Grid>
            <Grid item xs={7}>
              {getAllContent(activeStep)}
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  return (
    <CustomDialog
      fullScreen={true}
      isDialogOpen={props.isDialogOpen}
      dialogHeaderContent={dialogHeaderContent()}
      dialogTitleContent={dialogTitleContent()}
      handleDialogClose={props.handleCloseLeavedetailsForm}
    />
  );
};

export default NewLeaveApplication;
